export function formatPrice(price: number) {
  return price.toLocaleString(undefined, { maximumFractionDigits: 2, minimumFractionDigits: 2 });
}
